const JELLIESKINZ_PRODUCT_ID = "9150790959340";
const DREAMJELLIE_PRODUCT_ID = "9059398025452";
const BUNDLE_COLLECTION_TYPES = ["Forever Favorites", "The Specials"];

function getBundleCollectionType(variantLabel) {
  const normalized = String(variantLabel || "").toLowerCase();
  const specialKeywords = ["burst", "swirl", "crush", "zest", "sugar", "pop"];
  return specialKeywords.some((keyword) => normalized.includes(keyword))
    ? "The Specials"
    : "Forever Favorites";
}


function handleize(str) {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

function getSwatchImageUrl(variantLabel) {
  if (SWATCH_IMAGE_MAP[variantLabel]) {
    return SWATCH_CDN_BASE + SWATCH_IMAGE_MAP[variantLabel];
  }
  var filename = variantLabel.replace(/\s+/g, "_") + ".png?width=160";
  return SWATCH_CDN_BASE + filename;
}

function injectSwatchStyles() {
  if (document.getElementById("bndlr-swatch-styles")) {
    return;
  }
  const style = document.createElement("style");
  style.id = "bndlr-swatch-styles";
  style.textContent = `
    .bndlr-custom-variant-picker {
      margin-top: 10px;
      width: 100%;
    }
    .bndlr-variant-collection {
      margin-bottom: 12px;
    }
    .bndlr-variant-collection-title {
      margin: 8px 0 6px;
      font-weight: 600;
      font-size: 13px;
    }
    .bndlr-variant-options-grid {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      gap: 8px;
      width: max-content;
    }
  
    .bndlr-variant-input {
      position: relative;
      display: inline-block;
    }
    .bndlr-variant-radio {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
      opacity: 0;
      z-index: 2;
    }
    .bndlr-variant-swatch-label {
      display: block;
      cursor: pointer;
      border-radius: 50%;
      border: 2px solid transparent;
      transition: border-color 0.15s ease;
      padding: 2px;
    }
    .bndlr-variant-radio:checked + .bndlr-variant-swatch-label {
      border-color: #000;
    }
    .bndlr-variant-radio:focus-visible + .bndlr-variant-swatch-label {
      outline: 2px solid #000;
      outline-offset: 2px;
    }
    .bndlr-swatch-circle {
      display: block;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-size: cover;
      background-position: center;
    }
    .bndlr-swatch-sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0,0,0,0);
      white-space: nowrap;
      border: 0;
    }
    .bndlr-variant-picker-legend {
      font-size: 13px;
      margin-bottom: 4px;
    }
    .bndlr-variant-picker-legend .bndlr-selected-value {
      font-weight: 600;
    }
    .bndlr-second-picker-wrapper {
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid #e5e5e5;
    }
  `;
  document.head.appendChild(style);
}

function cloneJellieProduct(container) {
  var existing = container.querySelector(
    '.bndlr-product[data-cloned-jellie="true"]',
  );
  if (existing) {
    existing.style.display = "";
    return;
  }

  var original = container.querySelector(
    '.bndlr-product[data-product-id="' +
      JELLIESKINZ_PRODUCT_ID +
      '"]:not([data-cloned-jellie])',
  );
  if (!original) return;

  // Clone the raw product (before our restructuring) from the original's select
  var clone = document.createElement("div");
  clone.className = original.className;
  clone.setAttribute("data-product-id", JELLIESKINZ_PRODUCT_ID);
  clone.setAttribute("data-quantity", "1");
  clone.setAttribute(
    "data-required",
    original.getAttribute("data-required") || "false",
  );
  clone.setAttribute(
    "data-available",
    original.getAttribute("data-available") || "true",
  );
  clone.setAttribute("data-cloned-jellie", "true");

  // Add a title
  var titleDiv = document.createElement("div");
  titleDiv.className = "bndlr-title-above";
  var titleLink = document.createElement("a");
  titleLink.className = "bndlr-product-title";
  titleLink.textContent = "JellieSkinz Pillowcase #2";
  titleLink.href = "#";
  titleLink.addEventListener("click", function (e) {
    e.preventDefault();
  });
  titleDiv.appendChild(titleLink);
  clone.appendChild(titleDiv);

  // Clone the original hidden select so the bundle app sees a real variant select
  var originalSelect = original.querySelector(".bndlr-select-variant");
  if (originalSelect) {
    var selectClone = originalSelect.cloneNode(true);
    selectClone.style.display = "none";
    clone.appendChild(selectClone);
  }

  // Clone the overlay structure
  var overlay = original.querySelector(".bndlr-product-overlay");
  if (overlay) {
    clone.appendChild(overlay.cloneNode(true));
  }

  // Insert clone after the original product
  original.insertAdjacentElement("afterend", clone);

  // Build swatch picker for the clone
  var cloneSelect = clone.querySelector(".bndlr-select-variant");
  if (cloneSelect) {
    buildCustomVariantPicker(clone, cloneSelect);
  }
}

function removeJellieClone(container) {
  var clone = container.querySelector(
    '.bndlr-product[data-cloned-jellie="true"]',
  );
  if (clone) clone.style.display = "none";
}

function cloneDreamJellieProduct(container) {
  var existing = container.querySelector(
    '.bndlr-product[data-cloned-dream="true"]',
  );
  if (existing) {
    existing.style.display = "";
    return;
  }

  var original = container.querySelector(
    '.bndlr-product[data-product-id="' +
      DREAMJELLIE_PRODUCT_ID +
      '"]:not([data-cloned-dream])',
  );
  if (!original) return;

  var clone = document.createElement("div");
  clone.className = original.className;
  clone.setAttribute("data-product-id", DREAMJELLIE_PRODUCT_ID);
  clone.setAttribute("data-quantity", "1");
  clone.setAttribute(
    "data-required",
    original.getAttribute("data-required") || "false",
  );
  clone.setAttribute(
    "data-available",
    original.getAttribute("data-available") || "true",
  );
  clone.setAttribute("data-cloned-dream", "true");

  // Clone the original hidden select so the bundle app sees a real variant select
  var originalSelect = original.querySelector(".bndlr-select-variant");
  if (originalSelect) {
    var selectClone = originalSelect.cloneNode(true);
    selectClone.style.display = "none";
    clone.appendChild(selectClone);
  }

  // Clone the overlay structure
  var overlay = original.querySelector(".bndlr-product-overlay");
  if (overlay) {
    clone.appendChild(overlay.cloneNode(true));
  }

  // Insert clone after the original product
  original.insertAdjacentElement("afterend", clone);
}

function removeDreamJellieClone(container) {
  var clone = container.querySelector(
    '.bndlr-product[data-cloned-dream="true"]',
  );
  if (clone) clone.style.display = "none";
}

function initTwoPackBundle(container) {
  if (!container) return;
  // Only auto-clone for bundles with data-bndlr-ccid="gkbp"
  var bundleRoot = container.closest(".bundler-target-element");
  if (!bundleRoot || bundleRoot.getAttribute("data-bndlr-ccid") !== "gkbp")
    return;
  // Already initialized
  if (container.getAttribute("data-bndlr-2pack-init")) return;
  container.setAttribute("data-bndlr-2pack-init", "true");

  // Keep all existing products at quantity 1, clone both as second products
  container.querySelectorAll(".bndlr-product").forEach(function (product) {
    product.setAttribute("data-quantity", "1");
  });
  cloneDreamJellieProduct(container);
  cloneJellieProduct(container);
}

function buildCustomVariantPicker(product, selectElement) {
  if (!selectElement || product.querySelector(".bndlr-custom-variant-picker")) {
    return;
  }

  injectSwatchStyles();

  const options = Array.from(selectElement.options).map((option) => {
    const fullLabel = option.textContent || "";
    const valueLabel = fullLabel.includes(" - ")
      ? fullLabel.split(" - ").slice(1).join(" - ").trim()
      : fullLabel.trim();

    return {
      id: option.value,
      label: valueLabel,
      handle: handleize(valueLabel),
      selected: option.selected,
      collection: getBundleCollectionType(valueLabel),
    };
  });

  if (!options.length) {
    return;
  }

  const picker = document.createElement("div");
  picker.className = "bndlr-custom-variant-picker";

  const fieldset = document.createElement("fieldset");
  fieldset.className = "bndlr-variant-picker-fieldset";
  fieldset.style.border = "none";
  fieldset.style.padding = "0";
  fieldset.style.margin = "0";

  const legend = document.createElement("legend");
  legend.className = "bndlr-variant-picker-legend";
  const selectedOption = options.find((o) => o.selected) || options[0];
  legend.innerHTML =
    'Color: <span class="bndlr-selected-value">' +
    selectedOption.label +
    "</span>";
  fieldset.appendChild(legend);

  const isClone = product.hasAttribute("data-cloned-jellie");
  const idSuffix = isClone ? "-clone" : "";
  const groupName = `bndlr-variant-${product.getAttribute("data-product-id")}${idSuffix}`;

  BUNDLE_COLLECTION_TYPES.forEach((collectionName) => {
    const collectionVariants = options.filter(
      (v) => v.collection === collectionName,
    );
    if (!collectionVariants.length) {
      return;
    }

    const collectionBlock = document.createElement("div");
    collectionBlock.className = "bndlr-variant-collection";
    collectionBlock.setAttribute("data-collection", collectionName);

    const heading = document.createElement("p");
    heading.className = "bndlr-variant-collection-title";
    heading.textContent = collectionName;
    collectionBlock.appendChild(heading);

    const optionsGrid = document.createElement("div");
    optionsGrid.className = "bndlr-variant-options-grid";

    collectionVariants.forEach((variant, index) => {
      const inputId = `bndlr-swatch-${product.getAttribute("data-product-id")}${idSuffix}-${variant.handle}`;

      const wrapper = document.createElement("div");
      wrapper.className = "bndlr-variant-input";

      const input = document.createElement("input");
      input.type = "radio";
      input.id = inputId;
      input.name = groupName;
      input.value = variant.id;
      input.className = "bndlr-variant-radio";
      input.setAttribute("data-handle", variant.handle);
      if (variant.selected) {
        input.checked = true;
      }

      input.addEventListener("change", () => {
        if (!input.checked) {
          return;
        }
        selectElement.value = variant.id;
        selectElement.dispatchEvent(new Event("change", { bubbles: true }));

        const legendValue = fieldset.querySelector(".bndlr-selected-value");
        if (legendValue) {
          legendValue.textContent = variant.label;
        }
      });

      const label = document.createElement("label");
      label.setAttribute("for", inputId);
      label.className = "bndlr-variant-swatch-label";
      label.title = variant.label;

      const swatchCircle = document.createElement("span");
      swatchCircle.className = "bndlr-swatch-circle";
      swatchCircle.style.backgroundImage =
        "url(" + getSwatchImageUrl(variant.label) + ")";
      swatchCircle.style.backgroundPosition = "50% 50%";

      const srText = document.createElement("span");
      srText.className = "bndlr-swatch-sr-only";
      srText.textContent = variant.label;

      label.appendChild(swatchCircle);
      label.appendChild(srText);

      wrapper.appendChild(input);
      wrapper.appendChild(label);
      optionsGrid.appendChild(wrapper);
    });

    collectionBlock.appendChild(optionsGrid);
    fieldset.appendChild(collectionBlock);
  });

  picker.appendChild(fieldset);

  if (fieldset.querySelectorAll(".bndlr-variant-input").length > 0) {
    selectElement.style.display = "none";
    selectElement.insertAdjacentElement("afterend", picker);
  }
}

function restructureProduct(product) {
  const productId = product.getAttribute("data-product-id");

  // Hide DreamJellie product and all product image links
  if (
    productId === DREAMJELLIE_PRODUCT_ID &&
    !product.hasAttribute("data-cloned-dream")
  ) {
    product.classList.add("off-paper--hidden");
    product.setAttribute("data-bndlr-force-hidden", "true");
  }

  // Hide titles for DreamJellie products (original and clones)
  if (productId === DREAMJELLIE_PRODUCT_ID) {
    var dreamTitle = product.querySelector(".bndlr-product-title");
    if (dreamTitle) dreamTitle.style.display = "none";
    var dreamTitleAbove = product.querySelector(".bndlr-title-above");
    if (dreamTitleAbove) dreamTitleAbove.style.display = "none";
  }

  product.querySelectorAll(".bndlr-product-image-url").forEach(function (el) {
    el.classList.add("off-paper--hidden");
    el.setAttribute("data-bndlr-force-hidden", "true");
  });

  const notifyButton = product.querySelector(".klaviyo-bis-trigger");
  if (notifyButton) {
    notifyButton.style.display = "none";
  }

  const hiddenElements = product.querySelectorAll(
    ".off-paper--hidden:not([data-bndlr-force-hidden])",
  );
  hiddenElements.forEach((element) => {
    element.classList.remove("off-paper--hidden");
  });

  const title = product.querySelector(".bndlr-product-title");
  if (title && !product.querySelector(".bndlr-title-above")) {
    const titleWrapper = document.createElement("div");
    titleWrapper.className = "bndlr-title-above";
    product.insertBefore(titleWrapper, product.firstChild);

    titleWrapper.appendChild(title);

    const titleContainer = product.querySelector(".bndlr-product-qn-container");
    if (titleContainer && titleContainer.children.length === 0) {
      titleContainer.remove();
    }
  }

  const description =
    typeof productDescriptionMap !== "undefined"
      ? productDescriptionMap[productId]
      : null;

  if (description && !product.querySelector(".bndlr-product-description")) {
    const descriptionElement = document.createElement("div");
    descriptionElement.className = "bndlr-product-description";
    descriptionElement.textContent = description;

    const titleWrapper = product.querySelector(".bndlr-title-above");
    if (titleWrapper) {
      titleWrapper.insertAdjacentElement("afterend", descriptionElement);
    } else {
      product.insertBefore(descriptionElement, product.firstChild);
    }
  }

  if (!product.querySelector(".bndlr-product-content-wrapper")) {
    const contentWrapper = document.createElement("div");
    contentWrapper.className = "bndlr-product-content-wrapper";

    Array.from(product.children).forEach((child) => {
      if (
        !child.classList.contains("bndlr-title-above") &&
        !child.classList.contains("bndlr-product-description")
      ) {
        contentWrapper.appendChild(child);
      }
    });

    const descriptionElement = product.querySelector(
      ".bndlr-product-description",
    );
    if (descriptionElement) {
      descriptionElement.insertAdjacentElement("afterend", contentWrapper);
    } else {
      const titleWrapper = product.querySelector(".bndlr-title-above");
      if (titleWrapper) {
        titleWrapper.insertAdjacentElement("afterend", contentWrapper);
      } else {
        product.insertBefore(contentWrapper, product.firstChild);
      }
    }
  }

  if (productId === JELLIESKINZ_PRODUCT_ID) {
    const variantSelect = product.querySelector(".bndlr-select-variant");
    buildCustomVariantPicker(product, variantSelect);
  }
}


function handleDynamicElements() {
  const klaviyoButtons = document.querySelectorAll(
    ".klaviyo-bis-trigger:not([data-bndlr-hidden])",
  );
  klaviyoButtons.forEach((button) => {
    button.style.display = "none";
    button.setAttribute("data-bndlr-hidden", "true");
  });

  const hiddenElements = document.querySelectorAll(
    ".off-paper--hidden:not([data-bndlr-force-hidden])",
  );
  hiddenElements.forEach((element) => {
    element.classList.remove("off-paper--hidden");
  });
}

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        if (node.matches(".bndlr-product")) {
          restructureProduct(node);
        } else {
          node
            .querySelectorAll(".bndlr-product")
            .forEach((prod) => restructureProduct(prod));
        }
        if (node.matches(".klaviyo-bis-trigger")) {
          node.style.display = "none";
          node.setAttribute("data-bndlr-hidden", "true");
        }

        if (node.matches(".off-paper--hidden")) {
          node.classList.remove("off-paper--hidden");
        } else {
          handleDynamicElements();
        }

        // Inject pack selector if bundle container appeared
        if (
          node.matches(".bndlr-products-container") ||
          node.querySelector(".bndlr-products-container")
        ) {
          var containers = node.matches(".bndlr-products-container")
            ? [node]
            : Array.from(node.querySelectorAll(".bndlr-products-container"));
          containers.forEach(function (c) {
            initTwoPackBundle(c);
          });
        }
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

document
  .querySelectorAll(".bndlr-product")
  .forEach((prod) => restructureProduct(prod));

document.querySelectorAll(".bndlr-products-container").forEach((container) => {
  initTwoPackBundle(container);
});

handleDynamicElements();

let dynamicElementsInterval = setInterval(() => {
  handleDynamicElements();
}, 1000);

setTimeout(() => {
  clearInterval(dynamicElementsInterval);
}, 30000);


